import {Component, inject, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MatSort} from "@angular/material/sort";
import {SelectionModel} from "@angular/cdk/collections";
import {Router} from "@angular/router";
import {
  faArrowUpRightFromSquare,
  faBars,
  faBuilding,
  faEllipsisVertical,
  faFile,
  faGrid2,
  faGrip,
  faListCheck,
  faMagnifyingGlass,
  faNetworkWired,
  faPlus,
  faUser,
  faUserGroup
} from "@fortawesome/pro-solid-svg-icons";
import {
  AuthControllerService,
  Organisation,
  OrganisationControllerService,
  ProjectControllerService,
  User,
} from "../../api";
import {ToolbarService} from "../util/design/toolbar/toolbar.service";
import {StateConfigService} from "../../services/state/state-config.service";
import {PermissionService} from "../../services/permission/permission.service";
import {MatDialog} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";

import {BicCardComponent} from "../util/design/bic-card/bic-card.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {faSpinnerThird} from "@fortawesome/pro-duotone-svg-icons";
import {
  BicButtonComponent,
  BicDropdownComponent,
  BicDropdownElementComponent,
  BicDropdownTriggerDirective,
  BicInputComponent,
  BicPopupComponent
} from "@buildinginformationcloud/bic-ui-components";
import {PageHeaderComponent} from "../util/design/page-header/page-header.component";


@Component({
  selector: 'app-organisationList-list',
  templateUrl: './organisations.component.html',
  styleUrls: ['./organisations.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BicCardComponent,
    FaIconComponent,
    BicButtonComponent,
    BicDropdownComponent,
    BicDropdownElementComponent,
    BicDropdownTriggerDirective,
    BicPopupComponent,
    BicInputComponent,
    PageHeaderComponent,
  ]
})
export class OrganisationsComponent implements OnInit {
  stateService = inject(StateConfigService);
  permissionService = inject(PermissionService);
  projectControllerService = inject(ProjectControllerService);
  protected router = inject(Router);
  private organisationService = inject(OrganisationControllerService);
  private dialog = inject(MatDialog);
  private toolbar = inject(ToolbarService);
  private authControllerService = inject(AuthControllerService);


  displayedColumns: string[] = ['select', 'name', 'image', 'id', 'projectManager', 'projectOwner', 'lastCheck', 'actions'];

  @Input() user!: User;

  dataSource: MatTableDataSource<Organisation> = new MatTableDataSource<Organisation>();
  selection = new SelectionModel<Organisation>(true, []);

  numberOfPersonalProjects: number = 0;

  isCardView: boolean = false;
  loading = true;

  setCardView(): void {
    this.isCardView = true;
    localStorage.setItem('isOrganisationListView', 'false');
  }

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('projectsTbSort') projectsTbSort = new MatSort();

  /**
   * All Project of User
   */
  organisations: Organisation[] = [];
  selectedOrganisation!: Organisation | undefined;


  leaveOrganisationBoolean: boolean = false;
  deleteOrganisationBoolean: boolean = false;
  deleteAndLeaveOrganisationBoolean: boolean = false;





  adminMap: Map<Organisation, boolean> = new Map<Organisation, boolean>();
  otherAdmins: Map<number, boolean> = new Map<number, boolean>();
  filterValue: string = '';
  protected readonly faSpinnerThird = faSpinnerThird;

  /**
   * Initialization of Component
   */

  ngOnInit(): void {

 this.authControllerService.profile().subscribe(user =>
      {
        this.user = user;
        this.numberOfPersonalProjects = this.user.numberOfPersonalProjects ?? 0;
        this.loadOrganisations();
        this.setCardView();
      })
  }

  loadOrganisations() {
    this.organisationService.getOrganisations().subscribe(organisation => {
      this.organisations = organisation;
      this.dataSource = new MatTableDataSource(this.organisations);
      // ensure filter works on organisationList.name (case-insensitive)
      this.dataSource.filterPredicate = (data: Organisation, filter: string) => {
        if (!filter) return true;
        return (data.name ?? '').toLowerCase().includes(filter);
      };
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.organisations.forEach(org => {
        this.stateService.organisations.get(org.id ?? 0)?.privileges?.length == 6 ? this.adminMap.set(org, true) : this.adminMap.set(org, false);
      });

      this.organisationService.otherAdmins1(this.getAdminOrganisationIds()).subscribe(admins => {
        this.otherAdmins = this.convertToMap(admins);
      });
      this.loading = false;

    });

  }

  /**
   * Minimal filter: called from the search input, sets the dataSource.filter value.
   */
  applyFilter(value: string) {
    if (!this.dataSource) return;
    this.filterValue = (value || '').trim().toLowerCase();
    this.dataSource.filter = this.filterValue;
  }

  navigateToOrganisation(row: Organisation) {
    this.stateService.selectedProject = undefined as any;
    this.stateService.selectOrganisation(row.id!);
  }

  navigateToPersonalProjects(): void {
    this.stateService.selectProject(undefined, false);
    this.stateService.selectOrganisation(undefined, true, true);
  }

  routerNavigateToOrganisation(organisation: Organisation){
    this.router.navigate(['/organisations', organisation.id, 'settings']);
  }

  openNewOrganisation(){
    // let ref = this.dialog.open(OrganisationPopupComponent, {
    //   panelClass: 'rounded-corners-dialog',
    //   data: {
    //     title: "Neue Organisation"
    //   },
    //   width: '60%',
    // });
    // ref.afterClosed().subscribe(user => {
    //   this.stateService.update();
    //   this.ngOnInit();
    // });

    this.router.navigate(['/organisations', 'create']);

  }

  // openEditOrganisation(organisationId: number){
  //   let ref = this.dialog.open(OrganisationPopupComponent, {
  //     panelClass: 'rounded-corners-dialog',
  //     data: {
  //       organisationId: organisationId,
  //       title: "Unternehmenseinstellungen"
  //     },
  //     width: '60%',
  //   });
  //
  //   ref.afterClosed().subscribe(user => {
  //     this.stateService.update();
  //     this.ngOnInit();
  //   });
  // }

  navigateToOrganisationSettings(org: Organisation) {

    this.router.navigate(['/organisations', org.id, 'settings']);
    this.stateService.selectOrganisation(org.id, false)
  }


  openLeaveOrganisation(org: Organisation){
    this.leaveOrganisationBoolean = true;
    this.selectedOrganisation = org;
  }

  leaveOrganisation(org: Organisation){

    if(org.id != undefined){
      this.organisationService.leaveOrganisation(org.id).subscribe(() => {
        this.organisations = this.organisations.filter(obj => obj !== org);
        this.dataSource = new MatTableDataSource(this.organisations);
      });
    }
    this.leaveOrganisationBoolean = false;
  }

  openDeleteOrganisation(org: Organisation){
    this.deleteOrganisationBoolean = true;
    this.selectedOrganisation = org;
  }

  openDeleteAndLeaveOrganisation(org: Organisation){
    this.deleteAndLeaveOrganisationBoolean = true;
    this.selectedOrganisation = org;
  }

  deleteOrganisation(org: Organisation){
    if(org.id != undefined){
      this.organisationService.deleteOrganisation(org.id).subscribe(() => {
        this.organisations = this.organisations.filter(obj => obj !== org);
        this.dataSource = new MatTableDataSource(this.organisations);
      });
    }
    this.deleteOrganisationBoolean = false;
    this.deleteAndLeaveOrganisationBoolean = false;
  }

  // routeToProjectsOfPersonal(){
  //   this.stateService.isPersonal = true;
  //   this.stateService.selectOrganisation(undefined, false)
  // }


  calculateSizeInMB(size: number): number {
    return size / 1024 / 1024;
  }

  getNumberOfProjects(org: Organisation){
    let numb = 0;
    this.projectControllerService.getProjectsByOrganisationId(org.id ?? 0).subscribe( orgs => {
      numb =  orgs.length ?? 0;
    })
    return numb
  }

  getIsAdmin(org: Organisation){
    return this.adminMap.get(org);
  }

  getAdminOrganisationIds(): number[] {
    const adminOrganisationIds: number[] = [];
    this.adminMap.forEach((isAdmin, organisation) => {
      if (isAdmin) {
        // Stellen Sie sicher, dass die Organisation eine ID hat, bevor Sie sie hinzufügen
        if (organisation.id !== undefined) {
          adminOrganisationIds.push(organisation.id);
        }
      }
    });
    return adminOrganisationIds;
  }

convertToMap(obj: { [key: string]: boolean }): Map<number, boolean> {
    const map = new Map<number, boolean>();
    for (const [key, value] of Object.entries(obj)) {
      const numericKey = parseInt(key, 10);
      if (!isNaN(numericKey)) {
        map.set(numericKey, value);
      }
    }
    return map;
  }


  protected readonly faBars = faBars;
  protected readonly faGrip = faGrip;
  protected readonly faEllipsisVertical = faEllipsisVertical;
  protected readonly faPlus = faPlus;
  protected readonly faFile = faFile;
  protected readonly faUser = faUser;
  protected readonly faListCheck = faListCheck;
  protected readonly faUserGroup = faUserGroup;
  protected readonly faBuilding = faBuilding;

  protected readonly faNetworkWired = faNetworkWired;
    protected readonly faGrid2 = faGrid2;
  protected readonly faArrowUpRightFromSquare = faArrowUpRightFromSquare;
  protected readonly faMagnifyingGlass = faMagnifyingGlass;

  /**
   * Returns true when the personal profile entry should be visible:
   * no active filter, or the filter matches "persönlich" or the user's name.
   */
  showPersonalProfile(): boolean {
    if (!this.filterValue) return true;
    const personalLabel = 'persönlich';
    const fullName = `${this.user?.firstName ?? ''} ${this.user?.lastName ?? ''}`.trim().toLowerCase();
    return personalLabel.includes(this.filterValue) || fullName.includes(this.filterValue);
  }
}
